module.exports = __webpack_public_path__ + "vu.svg?9c4c893a4c07eab2b1b6b9e5419f1785";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/vu.svg
// module id = 1438
// module chunks = 0